import {RouteEntry} from "../../shared/routes";
import {MyClaim} from "./MyClaim";
import {TrackMyClaim} from "../track/TrackMyClaim";

export const myClaimRoutes: Array<RouteEntry> = [
    { path: '/my-claim/:id', component: MyClaim},
    { path: '/my-claim/', component: TrackMyClaim},
];
